import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { crearMenu, actualizarMenu } from "../service/menusService";

const MenuFormModal = ({ open, onClose, menu, proveedores = [], refresh, showToast }) => {
  const [nombre, setNombre] = useState("");
  const [idProveedor, setIdProveedor] = useState("");
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setNombre(menu?.nombre || "");
    setIdProveedor(menu?.id_proveedor || "");
    setErrors({});
  }, [menu, open]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!nombre.trim()) newErrors.nombre = "El nombre es obligatorio";
    if (!idProveedor) newErrors.idProveedor = "Elegí un proveedor";
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setSaving(true);
    try {
      if (menu) {
        await actualizarMenu(menu.id, nombre.trim(), idProveedor);
        showToast("Menú actualizado.", "success");
      } else {
        await crearMenu(idProveedor, nombre.trim());
        showToast("Menú creado.", "success");
      }
      await refresh();
      onClose();
    } catch (err) {
      showToast(err.message || "Error al guardar el menú.", "error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.main" }}>
          {menu ? "Editar menú" : "Nuevo menú"}
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 3 }}>
          <FormControl fullWidth error={!!errors.idProveedor}>
            <InputLabel>Proveedor</InputLabel>
            <Select
              label="Proveedor"
              value={idProveedor}
              onChange={(e) => {
                setIdProveedor(e.target.value);
                setErrors((p) => ({ ...p, idProveedor: undefined }));
              }}
            >
              {proveedores.map((p) => (
                <MenuItem key={p.id} value={p.id}>
                  {p.nombre}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Nombre del menú"
            value={nombre}
            onChange={(e) => {
              setNombre(e.target.value);
              setErrors((p) => ({ ...p, nombre: undefined }));
            }}
            error={!!errors.nombre}
            helperText={errors.nombre}
          />
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={onClose} color="inherit">
            Cancelar
          </Button>
          <Button type="submit" variant="contained" disabled={saving}>
            {menu ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default MenuFormModal;
